"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleSelectInput = void 0;
const react_1 = __importDefault(require("react"));
const SelectPill_1 = require("../buttons/SelectPill");
const SingleSelectInput = ({ onItemClick, items, }) => (react_1.default.createElement("div", { className: "flex flex-row items-start w-full" },
    react_1.default.createElement("div", { className: "flex flex-col" },
        react_1.default.createElement("div", { className: "flex flex-row flex-wrap" }, items.map((item, index) => (react_1.default.createElement(SelectPill_1.SelectPill, { key: index, textContent: item, onClick: () => onItemClick(item), uniqueChoice: true })))))));
exports.SingleSelectInput = SingleSelectInput;
//# sourceMappingURL=SingleSelectInput.js.map